export const CCM_SCRIPT_ID = 'cookie-consent-manager';
export const CCM_BANNER_ID = 'iubenda-cs-banner';
